import { useState } from 'react'

/**
 * Logo officiel Manrina : le renard (/03-logo_icone.png, fond transparent).
 *
 * Regle branding (cf. docs/CONVENTIONS.md) : ne JAMAIS representer Manrina
 * par l'emoji mangue. Si l'image ne charge pas, le fallback est l'emoji
 * renard, coherent avec le logo.
 *
 * @param className     classes Tailwind de l'image (taille)
 * @param emojiClassName classes du fallback emoji (taille de police)
 */
export default function LogoManrina({ className = 'w-8 h-8', emojiClassName = 'text-2xl' }) {
  const [imageEnEchec, setImageEnEchec] = useState(false)

  if (imageEnEchec) {
    return (
      <span className={`${emojiClassName} leading-none`} role="img" aria-label="Manrina">
        🦊
      </span>
    )
  }

  return (
    <img
      src="/03-logo_icone.png"
      alt="Manrina"
      className={`${className} object-contain`}
      onError={() => setImageEnEchec(true)}
    />
  )
}
